import { getConfig } from '@edx/frontend-platform';
import { getLocale, useIntl } from '@edx/frontend-platform/i18n';
import { StatefulButton } from '@edx/paragon';
import PropTypes from 'prop-types';

import messages from './messages';
import terms from './translations';
import Decorations from '../common-components/Decorations';

const TermsOfService = ({ handleClose }) => {
  const { formatMessage } = useIntl();

  const locale = getLocale();
  const TermsContent = terms[locale] || terms.he;

  return (
    <div className="terms-of-service-page">
      <h1 className="page-title">{formatMessage(messages['terms.of.service.page.title'], { platformName: getConfig().SITE_NAME })}</h1>
      <div className="terms-content">
        <TermsContent />
      </div>
      <StatefulButton
        id="next-step"
        name="next-step"
        type="submit"
        className="logistration-btn"
        labels={{
          default: formatMessage(messages['terms.of.service.page.button']),
        }}
        onClick={handleClose}
      />
      <Decorations showFooter={false} />
    </div>
  );
};

TermsOfService.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

export default TermsOfService;
